import React from 'react';
import { CustomOptionResolvers, jsonPagesToStructure } from '@europrocurement/flexy-form';
import { jsonForm, visibilityType } from '@europrocurement/flexy-form/utils/types/formTypes';
import { Box, useTheme } from '@mui/material';
import { FormulaireFormalite } from '@europrocurement/l2d-domain';
import { customItemRenderer } from '../customItems/customItemRenderer';
import AccordionJsonForm from './AccordionJsonForm';
import { useListeSelectionDataResolver } from '../../hooks';

export type AccordionJsonFormsProps = {
    json: jsonForm;
    formulaireId: number;
    formaliteId: number;
    visibility?: visibilityType;
    defaultValues: Record<string, unknown>;
    expanded?: boolean;
    onChange: (data: Record<string, unknown>) => void;
};

const getStructureKey = (formulaireId: number, index: number) =>
    `accordion-${formulaireId}-structure-${index}`;

const AccordionJsonForms: React.FunctionComponent<AccordionJsonFormsProps> = function ({
    json,
    formulaireId,
    formaliteId,
    visibility = 'FULL',
    defaultValues,
    expanded = false,
    onChange: handleChange,
}) {
    const structures = jsonPagesToStructure(json, visibility, (formContext, props) =>
        customItemRenderer(formContext, props, visibility),
    );
    const { palette } = useTheme();

    const createListeSelectionDataResolver = useListeSelectionDataResolver();
    const customOptionResolvers: CustomOptionResolvers = {
        listeSelectionDataResolver: createListeSelectionDataResolver({
            formalites: [`/formalite/formalites/${formaliteId}`],
            id: formulaireId,
        } as FormulaireFormalite),
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px 0' }}>
            {structures.map((structure, index) => (
                <AccordionJsonForm
                    key={getStructureKey(formulaireId, index)}
                    structure={structure}
                    customOptionResolvers={customOptionResolvers}
                    accordionSx={{ backgroundColor: palette.background.paper }}
                    defaultValues={defaultValues}
                    expanded={expanded}
                    onChange={handleChange}
                />
            ))}
        </Box>
    );
};

export default AccordionJsonForms;
